<template>
	<WinWinHeader />
	<Header />
	<AdminHeader />
	<div v-if="error">
		<Modal />
	</div>
	<div class="cont py-8 sm:py-16 px-6 sm:px-24">
		<router-view />
	</div>
	<WinWinFooter />
</template>

<script>
	import { mapGetters } from "vuex";

	import Header from "@/components/Header";
	import AdminHeader from "@/components/AdminHeader";
	import Modal from "@/components/Modal";

	import WinWinHeader from "@/components/WinWinHeader";
	import WinWinFooter from "@/components/WinWinFooter";

	export default {
		components: {
			Header,
			AdminHeader,
			Modal,
			WinWinHeader,
			WinWinFooter,
		},
		computed: {
			...mapGetters({
				user: "user",
				error: "error",
			}),
		},
	};
</script>

<style>
	@import "./assets/styles.scss";

	.cont {
		width: 100%;
		margin: 0 auto;
		min-height: 70vh;
		background: linear-gradient(0deg, rgba(26, 31, 86, 0.85), #000000);
	}

	#app {
		font-family: montserrat, sans-serif;
		font-weight: 400;
		font-style: normal;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		color: #2c3e50;
	}

	#nav {
		padding: 30px;
	}

	#nav a {
		font-weight: bold;
		color: #2c3e50;
	}

	#nav a.router-link-exact-active {
		color: #42b983;
	}

	.wwg-1 {
		background-color: #eaeaea;
	}
</style>
